import {getMemberInitialData, getMemberInitialDataWithoutToken} from "../api/graphql/initialDataSetup";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import i18next from "i18next";
import {
    globalAvailableProductState,
    globalBrandConfigState,
    globalBrandModuleSettingLoadingState,
    globalBrandModuleSettingState,
    globalBrandSettingState,
    globalDashboardEducationState,
    globalDashboardEducationLoadingState,
    globalDashboardMarketNewsState,
    globalDashboardNewsletterState,
    globalDashboardOpportunityState,
    globalDashboardPromotionLoadingState,
    globalDashboardPromotionState,
    globalDashboardSymbolPriceState,
    globalDefaultWebModuleSettingState,
    globalEducationPostingState,
    globalEWalletSettingState,
    globalHasProductState,
    globalIconListState,
    globalLanguageListState,
    globalLanguageLoadingState,
    globalNotificationState,
    globalPNServerSettingState,
    globalProfileSetting,
    globalReferralSettingState,
    globalServerSettingState,
    globalSymbolCategoryLoadingState,
    globalSymbolCategoryState,
    globalUserDefaultTradingAccount,
    globalUserSettingsState,
    globalUserTradingAccount,
    globalWebModuleSettingState, globalDashboardSymbolPriceLoadingState,
} from "./global_state";
import {getUserFavouriteSymbol} from "../api/graphql/favouriteSymbol";
import {getTradingAccount} from "../api/graphql/tradingAccount";
import {getEducationCategory, getEducationPosting,} from "../api/restful/education";
import {getMarketNews} from "../api/restful/marketNews";
import {getOpportunities} from "../api/graphql/tradeIdeas";
import {getNewsletter} from "../api/graphql/newsletter";
import {getPromotions} from "../api/restful/promotion";
import {getInstruments} from "../api/graphql/symbol";
import {getSymbolPrice, getSymbolPriceMt5} from "../api/graphql/symbolPrice";
import {getDefaultWebModuleSetting, getUserPreferenceNavigation,} from "../api/graphql/webModuleSetting";
import {getReferralSetting} from "../api/graphql/referralSetting";
import useShared from "./_shared";
import {getSymbolMappingCategory} from "../api/graphql/symbolCategory";
import {categoryFakeData} from "../../config/categoryFakeData";
import {getUserSettingByUserID} from "../api/graphql/user";
import {getPNServerSettingWithoutToken} from "../api/graphql/pushNotification";
import {openDB} from "idb"
import {getLanguage, getLanguageVersion} from "../api/graphql/language";

const dbPromise = openDB("app-db", 1, {
    upgrade(db) {
        db.createObjectStore("kv")
    },
})

function usePreload() {
    const {convertLanguageFile, detectViewable, checkUserAccessRight} = useShared();

    const brandConfigState = useRecoilValue(globalBrandConfigState);
    const setLanguageListState = useSetRecoilState(globalLanguageListState);
    const setUserSettings = useSetRecoilState(globalUserSettingsState);
    const setUserTradingAccountState = useSetRecoilState(globalUserTradingAccount);
    const setUserDefaultTradingAccountState = useSetRecoilState(globalUserDefaultTradingAccount);
    const setProfileSetting = useSetRecoilState(globalProfileSetting);
    const setNotificationMessage = useSetRecoilState(globalNotificationState);
    const setDashboardEducation = useSetRecoilState(globalDashboardEducationState);
    const setDashboardEducationLoading = useSetRecoilState(globalDashboardEducationLoadingState);
    const setDashboardMarketNews = useSetRecoilState(globalDashboardMarketNewsState);
    const setDashboardOpportunity = useSetRecoilState(globalDashboardOpportunityState);
    const setDashboardNewsletter = useSetRecoilState(globalDashboardNewsletterState);
    const setDashboardPromotion = useSetRecoilState(globalDashboardPromotionState);
    const setDashboardPromotionLoading = useSetRecoilState(globalDashboardPromotionLoadingState);
    const setDashboardSymbolPrice = useSetRecoilState(globalDashboardSymbolPriceState);
    const setDashboardSymbolPriceLoading = useSetRecoilState(globalDashboardSymbolPriceLoadingState);
    const setIconListState = useSetRecoilState(globalIconListState);
    const setWebModuleSetting = useSetRecoilState(globalWebModuleSettingState);
    const setBrandModuleSetting = useSetRecoilState(globalBrandModuleSettingState);
    const setBrandModuleSettingLoading = useSetRecoilState(globalBrandModuleSettingLoadingState);
    const setReferralSetting = useSetRecoilState(globalReferralSettingState);
    const setDefaultWebModuleSetting = useSetRecoilState(globalDefaultWebModuleSettingState);
    const setEducationPosting = useSetRecoilState(globalEducationPostingState);
    const setSymbolCategoryState = useSetRecoilState(globalSymbolCategoryState);
    const setSymbolCategoryLoadingState = useSetRecoilState(globalSymbolCategoryLoadingState);
    const setHasProduct = useSetRecoilState(globalHasProductState);
    const setPNServerSetting = useSetRecoilState(globalPNServerSettingState);
    const setServerSetting = useSetRecoilState(globalServerSettingState);
    const setLanguageLoading = useSetRecoilState(globalLanguageLoadingState)
    const [availableProductState, setAvailableProductState] = useRecoilState(globalAvailableProductState);
    const [globalEWalletSetting, setEWalletSetting] = useRecoilState(globalEWalletSettingState);
    const [brandSettingState, setBrandSettingState] = useRecoilState(globalBrandSettingState);

    const cmsUrl = localStorage?.getItem("cmsUrl");
    const language = localStorage?.getItem("language");

    const getInitialDataWithoutToken = async () => {
        try {
            if (brandSettingState?.defaultDomain) return

            const initialDataWithoutToken = await getMemberInitialDataWithoutToken();
            const pushNotificationSetting = await getPNServerSettingWithoutToken("web", "firebase");

            const getLanguageDropdown = initialDataWithoutToken?.getLanguageDropdown?.data
            const getUserBrandSetting = initialDataWithoutToken?.getUserBrandSetting
            const getIconList = initialDataWithoutToken?.getIconList?.data
            const getReferralSetting = initialDataWithoutToken?.getReferralSetting
            const getPushNotificationSetting = pushNotificationSetting?.getPNServerSettingWithoutToken

            if (getReferralSetting) setReferralSetting(getReferralSetting)

            if (getLanguageDropdown) {
                let languageData = getLanguageDropdown;
                let languageList = [];
                window.lang = languageData;
                languageData?.forEach((item) => {
                    languageList.push({
                        name: item?.name,
                        code: item?.code,
                        countryCode: item?.countryCode,
                        nativeName: item?.nativeName
                    });
                });
                setLanguageListState(languageList);
            }

            if (getUserBrandSetting) {
                localStorage.setItem("timezone", getUserBrandSetting.timezone)
                setBrandSettingState(getUserBrandSetting);

                const currentDomain = await window.location.hostname?.includes("localhost") ? `member.${getUserBrandSetting?.website?.replace("https://", "")?.replace(/^www\./, "")}` : window.location.hostname;

                const cmsURL = currentDomain.includes("localhost") ? "antospnc.asia" : currentDomain?.replace(/member\.|stg\.|memberstg\./, "");
                const arenaURL = currentDomain?.replace(/member\.|stg\.|memberstg\./, "arena.");
                localStorage.setItem("cmsUrl", cmsURL);
                localStorage.setItem("arenaURL", arenaURL);
            }

            if (getIconList) setIconListState(getIconList);

            if (getPushNotificationSetting) setPNServerSetting(getPushNotificationSetting)
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the initial data. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    const getLatestLanguageVersion = async () => {
        try {
            if (brandSettingState?.defaultDomain) return

            const db = await dbPromise
            let languageData = await db.get("kv", `languageData_${language}`)

            if (!languageData) {
                setLanguageLoading(true)
            }

            const currentVersion = localStorage.getItem(`languageVersion_${language}`)
            const versionResponse = await getLanguageVersion()
            const latestVersion = versionResponse?.getLanguageVersion?.version

            const shouldFetch = !languageData || currentVersion !== latestVersion

            if (shouldFetch) {
                const response = await getLanguage(language)
                languageData = response?.getLanguage?.data

                if (languageData) {
                    await db.put("kv", languageData, `languageData_${language}`)
                    localStorage.setItem(`languageVersion_${language}`, latestVersion)
                }
            }

            if (languageData) {
                const languageFile = convertLanguageFile(languageData)

                window.lang = languageData

                languageData.forEach((item) => {
                    i18next.addResourceBundle(
                        item.code,
                        "translation",
                        languageFile?.[item.code]?.translation,
                        true,
                        true
                    )
                })
            }
        } catch (e) {
            console.error("Error:", e)
        } finally {
            setLanguageLoading(false)
        }
    }

    const getInitialData = async (userDetail) => {
        try {
            const initialData = await getMemberInitialData();

            const getAllAvailableProductByUserId = initialData?.getAllAvailableProductByUserId?.data
            // const getUserSettingByUserID = initialData?.getUserSettingByUserID?.data
            const getProfileInformationSetting = initialData?.getProfileInformationSetting?.data
            const getModuleSetting = initialData?.getModuleSetting?.data
            const eWalletSetting = initialData?.getEWalletSetting
            setEWalletSetting(eWalletSetting)

            if (getAllAvailableProductByUserId) {
                const productOptions =
                    getAllAvailableProductByUserId.map((p) => {
                        return {
                            label: p.name,
                            value: p._id,
                            productType: p?.productType,
                            minDeposit: p?.minDeposit,
                            leverage: p?.leverage,
                            server: p?.server,
                            spreadGroup: p?.spreadGroup,
                        };
                    });
                setAvailableProductState(productOptions);
            }

            if (getProfileInformationSetting) setProfileSetting(getProfileInformationSetting)

            if (getModuleSetting) {
                const filteredModule = []
                if (eWalletSetting?.depositWithKyc && !checkUserAccessRight("ewallet-deposit")) {
                    filteredModule.push("ewallet-deposit")
                }

                if (eWalletSetting?.withdrawalWithKyc && !checkUserAccessRight("ewallet-withdrawal")) {
                    filteredModule.push("ewallet-withdrawal")
                }

                setBrandModuleSettingLoading(true)
                const amendedModuleSetting = getModuleSetting?.filter((r) => !filteredModule?.includes(r?.name))
                setBrandModuleSetting(amendedModuleSetting)
            }

            setBrandModuleSettingLoading(false);
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the initial data. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    // const getFirebaseToken = async () => {
    //     const removeTypename = (obj) =>
    //         Object.fromEntries(Object.entries(obj || {}).filter(([key]) => key !== "__typename")
    //             .map(([key, value]) => [key, value && typeof value === "object" ? removeTypename(value) : value]));
    //
    //     const firebaseConfig = removeTypename(PNServerSetting?.firebase?.config);
    //     let app;
    //
    //     if (getApps().length < 1) {
    //         app = initializeApp(firebaseConfig);
    //     } else {
    //         app = getApps()?.[0];
    //     }
    //     const messaging = getMessaging(app);
    //
    //     const getTokenFunction = async () => {
    //         try {
    //             // const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    //             // console.log("Service Worker registered: ", registration);
    //
    //             // Ensure the service worker is fully ready before requesting the token
    //             const currentToken = await getToken(messaging, {
    //                 vapidKey: PNServerSetting?.firebase?.vapid,
    //                 // serviceWorkerRegistration: registration
    //             });
    //
    //             if (currentToken) {
    //                 await updateUserPushNotificationToken({
    //                     user: localStorage.getItem("userid"),
    //                     token: currentToken,
    //                     provider: "firebase",
    //                     platform: "web"
    //                 });
    //             } else {
    //                 console.warn("No registration token available.");
    //             }
    //         } catch (e) {
    //             console.error("An error occurred while retrieving the token.", e);
    //         }
    //     };
    //
    //     Notification.requestPermission().then((permission) => {
    //         if (permission === "granted") {
    //             getTokenFunction();
    //         } else {
    //             console.error("Unable to get permission to notify.");
    //         }
    //     });
    //
    //     // Handle incoming messages while the app is in the foreground
    //     onMessage(messaging, (payload) => {
    //         console.log("Message received in foreground: ", payload);
    //         // Optionally display notifications
    //     });
    // };

    const getDashboardEducationPosting = async () => {
        try {
            if (detectViewable("Trade Ideas")) {
                const response = await getEducationPosting();
                setEducationPosting(response.data);
            }
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the education posting details. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    const defaultWebModuleSetting = async () => {
        try {
            const getDefaultSetting = await getDefaultWebModuleSetting();
            setDefaultWebModuleSetting(getDefaultSetting?.getWebModuleSetting?.data);
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the default module. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    const getReferralDataSetting = async () => {
        try {
            const referral = await getReferralSetting();
            setReferralSetting(referral?.getReferralSetting);
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the referral module. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    // const getAvailableProduct = async () => {
    //     try {
    //         const userId = localStorage.getItem("userid") || null;
    //
    //         if (!userId) return null
    //
    //         const availableProduct = await getAllAvailableProductByUserId(userId, [
    //             "selfTradeLive",
    //             "selfTradeDemo",
    //         ]);
    //         const productOptions =
    //             availableProduct?.getAllAvailableProductByUserId?.data?.map((p) => {
    //                 return {
    //                     label: p.name,
    //                     value: p._id,
    //                     productType: p?.productType,
    //                     minDeposit: p?.minDeposit,
    //                     leverage: p?.leverage,
    //                     server: p?.server,
    //                     spreadGroup: p?.spreadGroup,
    //                 };
    //             });
    //         setAvailableProductState(productOptions);
    //         return productOptions;
    //     } catch (e) {
    //         console.error("Error:", e);
    //     }
    // };

    const getDefaultTradingAccount = async () => {
        try {
            const userId = localStorage.getItem("userid") || null;
            const tradingAccounts = await getTradingAccount(userId);
            const accounts = tradingAccounts?.getTradingAccount?.data;
            const defaultAccount =
                accounts.find(
                    (item) => item?.mode === "live" && item?.isDefault === true
                ) || accounts.find((item) => item?.mode === "live");

            setUserTradingAccountState(accounts);
            setUserDefaultTradingAccountState(defaultAccount);

            return defaultAccount;
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the default trading account. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    // const getBrandSetting = async () => {
    //     try {
    //         const userId = localStorage.getItem("userid") || null;
    //         const language = localStorage.getItem("language") || "en";
    //         const brandSetting = await getUserBrandSetting({
    //             userid: userId,
    //             language: language,
    //         });
    //         setBrandSettingState(brandSetting.getUserBrandSetting);
    //         localStorage.setItem("timezone", brandSetting?.getUserBrandSetting?.timezone)
    //     } catch (e) {
    //         console.error("Error:", e);
    //         setNotificationMessage({
    //             status: "error",
    //             title: "",
    //             msg: "Apologies, we are currently undergoing maintenance for the brand setting details. We're actively working to resolve the issue.",
    //             key: "systemNotification",
    //         });
    //     }
    // };

    // const getProfileSetting = async () => {
    //     try {
    //         const profile = await getProfileInformationSetting();
    //         setProfileSetting(profile.getProfileInformationSetting.data);
    //     } catch (e) {
    //         console.error("Error:", e);
    //         setNotificationMessage({
    //             status: "error",
    //             title: "",
    //             msg: "Apologies, we are currently undergoing maintenance for the profile setting. We're actively working to resolve the issue.",
    //             key: "systemNotification",
    //         });
    //     }
    // };

    const getDashboardEducation = async () => {
        try {
            setDashboardEducationLoading(true);
            if (detectViewable("Education")) {
                const response = await getEducationCategory();
                setDashboardEducation(response.data);
            }
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the education details. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        } finally {
            setDashboardEducationLoading(false);
        }
    };

    const getDashboardMarketNews = async () => {
        try {
            if (detectViewable("Market News")) {
                const response = await getMarketNews();
                setDashboardMarketNews(response.data);
            }
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the market news details. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    const getDashboardOpportunity = async (baseSymbolId) => {
        try {
            if (detectViewable("Trade Ideas")) {
                const response = await getOpportunities(
                    localStorage.getItem("userid"),
                    null,
                    baseSymbolId || null,
                    6
                );
                setDashboardOpportunity(response?.article);
            }
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the opportunities details. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    const getDashboardNewsletter = async () => {
        try {
            if (detectViewable("Newsletter")) {
                const response = await getNewsletter();
                setDashboardNewsletter(response?.getNewsletter?.data);
            }
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the newsletter details. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    };

    const getDashboardPromotion = async () => {
        try {
            setDashboardPromotionLoading(true)
            if (cmsUrl) {
                const response = await getPromotions(cmsUrl);
                //const filtered = response?.data.filter((item) => item?.active === true);
                const filtered = response?.data.filter((item) => item?.status === "ACTIVE");
                // if (filtered.length < 4) {
                //     setDashboardPromotion([...filtered, ...filtered]);
                // } else {
                setDashboardPromotion(filtered);
                // }
            }
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the promotion details. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        } finally {
            setDashboardPromotionLoading(false)
        }
    };

    const getDashboardSymbolPrice = async (serverData, spreadGroup) => {
        try {
            const userId = localStorage.getItem("userid") || null;
            if (userId && serverData) {
                const userFavouriteSymbol = await getUserFavouriteSymbol(
                    userId,
                    serverData?._id
                );

                let symbol = [];

                if (serverData?.platform === "cTrader") {
                    const baseSymbolId = userFavouriteSymbol?.getUserFavouriteSymbol?.favouriteSymbol.map(d => d?.baseSymbolId) || []
                    const serverName = serverData?.name

                    const symbolPrice = await getSymbolPrice(
                        null,
                        spreadGroup,
                        serverName
                    );

                    const baseInstrumentData = await getInstruments(baseSymbolId.join(","));

                    await Promise.all(
                        (userFavouriteSymbol?.getUserFavouriteSymbol?.favouriteSymbol ?? []).map(async (item) => {
                            const detail = await baseInstrumentData?.find((symbol) => symbol?.base_symbol_id === Number(item?.baseSymbolId));
                            const price = await symbolPrice?.payload?.find((v) => v?.symbolId === Number(item?.symbolId));

                            symbol.push({
                                symbolName: item?.name,
                                ...price,
                                baseSymbolId: item?.baseSymbolId,
                                icon: detail?.icon_link || detail?.[0]?.icon_link || null,
                                instrumentName: detail?.instrument_name,
                            });
                        })
                    );

                } else if (brandConfigState?.tradeURL) {
                    const baseSymbolId = userFavouriteSymbol?.getUserFavouriteSymbol?.favouriteSymbolMt5.map(d => d?.baseSymbolId) || []
                    const baseInstrumentData = await getInstruments(baseSymbolId.join(","));
                    const symbolPrice = await getSymbolPriceMt5(brandConfigState?.tradeURL, null, spreadGroup)

                    // const decryptedSymbolPrice = decryptMT5Message(symbolPrice)

                    await Promise.all(
                        (userFavouriteSymbol?.getUserFavouriteSymbol?.favouriteSymbolMt5 ?? []).map(async (item) => {
                            const detail = await baseInstrumentData?.find((symbol) => symbol?.base_symbol_id === Number(item?.baseSymbolId));
                            const price = await symbolPrice?.payload?.find((v) => v?.symbol === item?.symbol);

                            symbol.push({
                                symbolName: price?.symbol,
                                ...price,
                                baseSymbolId: item?.baseSymbolId,
                                icon: detail?.icon_link || detail?.[0]?.icon_link || null,
                                instrumentName: detail?.instrument_name,
                            });
                        })
                    );

                }

                setDashboardSymbolPrice(symbol);
            }
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the symbol price details. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        } finally {
            setDashboardSymbolPriceLoading(false)
        }
    };

    const getSymbolMappingCategories = async (serverData) => {
        try {
            setSymbolCategoryLoadingState(true)

            const userId = localStorage.getItem("userid") || null;
            if (userId && serverData) {
                const symbolCategory = await getSymbolMappingCategory(serverData?.name);
                const symbolCategoryData = structuredClone(
                    symbolCategory?.getSymbolMappingCategory?.data ?? []
                );
                const baseSymbolIds = symbolCategoryData?.map((c) =>
                    c?.symbol?.map((s) => s?.baseSymbolId)
                );

                // Fetch instrument for icons
                const instruments = await getInstruments(baseSymbolIds.join(","));
                const instrumentMap =
                    instruments?.reduce(
                        (a, b) => ({...a, [b.base_symbol_id]: b}),
                        {}
                    ) || {};

                symbolCategoryData?.forEach((c) => {
                    (c.symbol || [])?.forEach((s) => {
                        const bsi = s.baseSymbolId;
                        s.icon = instrumentMap[bsi]?.icon_link ?? undefined;
                        // c.symbol = { ...c.symbol, icon: instrumentMap[bsi] ?? undefined };
                    });
                });

                setSymbolCategoryState(symbolCategoryData);
            }
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the symbol price details. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        } finally {
            setSymbolCategoryLoadingState(false)
        }
    };

    // const getIconLists = async () => {
    //     try {
    //         const iconList = await getIconList();
    //         setIconListState(iconList?.getIconList?.data);
    //     } catch (e) {
    //         console.error("Error:", e);
    //         setNotificationMessage({
    //             status: "error",
    //             title: "",
    //             msg: "Apologies, we are currently undergoing maintenance for the icon listing details. We're actively working to resolve the issue.",
    //             key: "systemNotification",
    //         });
    //     }
    // };

    // const getBrandModuleSetting = async () => {
    //     try {
    //         setBrandModuleSettingLoading(true);
    //         const brandModule = await getModuleSetting();
    //         setBrandModuleSetting(brandModule.getModuleSetting.data);
    //     } catch (e) {
    //         console.error("Error:", e);
    //         setNotificationMessage({
    //             status: "error",
    //             title: "",
    //             msg: "Apologies, we are currently undergoing maintenance for the web module setting. We're actively working to resolve the issue.",
    //             key: "systemNotification",
    //         });
    //     } finally {
    //         setBrandModuleSettingLoading(false);
    //     }
    // };

    const getUserPreferenceNavigations = async (userDetail) => {
        try {
            const module = await getUserPreferenceNavigation(userDetail?._id);
            const navList = module?.getUserPreferenceNavigation?.webNavigation

            const filteredModule = []
            if (globalEWalletSetting?.depositWithKyc && !checkUserAccessRight("ewallet-deposit")) {
                filteredModule.push("ewallet-deposit")
            }

            if (globalEWalletSetting?.withdrawalWithKyc && !checkUserAccessRight("ewallet-withdrawal")) {
                filteredModule.push("ewallet-withdrawal")
            }

            const amendedNavList = navList?.filter((r) => !filteredModule?.includes(r?.moduleId?.name))
            setWebModuleSetting(amendedNavList);
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the web module setting. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        } finally {
        }
    };

    const getUserSettings = async (userId) => {
        try {
            const response = await getUserSettingByUserID(userId);
            setUserSettings(response?.getUserSettingByUserID);
        } catch (e) {
            console.error("Error:", e);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the web module setting. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        } finally {
        }
    };

    // const getLanguages = async () => {
    //     try {
    //         const response = await getLanguage();
    //         if (response?.getLanguage?.data) {
    //             let languageData = response?.getLanguage?.data;
    //             let languageFile = convertLanguageFile(languageData);
    //             let languageList = [];
    //             window.lang = languageData;
    //             languageData?.forEach((item) => {
    //                 languageList.push({
    //                     name: item?.name,
    //                     code: item?.code,
    //                     countryCode: item?.countryCode,
    //                     nativeName: item?.nativeName
    //                 });
    //                 i18next.addResourceBundle(
    //                     item?.code,
    //                     "translation",
    //                     languageFile?.[item?.code]?.["translation"]
    //                 );
    //             });
    //             setLanguageListState(languageList);
    //         }
    //     } catch (e) {
    //         console.error("Error:", e);
    //     }
    // };

    const preload = async () => {
        const userId = localStorage.getItem("userid") || null;
        const language = localStorage.getItem("language") || "en";
        if (!language) {
            localStorage.setItem("language", "en");
        } else {
            i18next.changeLanguage(language);
        }

        if (brandConfigState?.backendURL) {
            if (userId) {
                const tradingAcc = await getDefaultTradingAccount();
                const products = availableProductState;
                let serverData, spreadGroup
                if (tradingAcc) {
                    serverData = tradingAcc?.product?.server
                    if (serverData?.platform === "cTrader") {
                        spreadGroup = tradingAcc?.spreadGroup?.name
                    } else {
                        spreadGroup = tradingAcc?.mt5SpreadGroup?.group
                    }
                } else {
                    serverData = products?.find((p) => p?.productType === "selfTradeLive")?.server
                    if (serverData?.platform === "cTrader") {
                        spreadGroup = products?.find((p) => p?.productType === "selfTradeLive")?.spreadGroup?.[0]?.name
                    } else {
                        spreadGroup = products?.find((p) => p?.productType === "selfTradeLive")?.spreadGroupMt5?.[0]?.group
                    }
                }

                if (serverData) {
                    localStorage.setItem("platform", serverData?.platform)
                    await getDashboardSymbolPrice(serverData, spreadGroup);
                    await getSymbolMappingCategories(serverData);
                    setServerSetting(serverData)
                    setHasProduct(true);
                } else {
                    localStorage.setItem("platform", "cTrader")
                    setHasProduct(false);
                    setSymbolCategoryState(categoryFakeData);
                }

                await getUserSettings(userId);
            }

            await defaultWebModuleSetting();
        }
    };

    return {
        preload,
        getInitialDataWithoutToken,
        getLatestLanguageVersion,
        getInitialData,
        // getFirebaseToken,
        // getBrandSetting,
        // getBrandModuleSetting,
        getUserPreferenceNavigations,
        // getLanguages,
        defaultWebModuleSetting,
        getReferralDataSetting,
        getDashboardMarketNews,
        getDashboardEducation,
        getDashboardEducationPosting,
        getDashboardOpportunity,
        getDashboardNewsletter,
        getDashboardPromotion,
        // getIconLists,
        getDashboardSymbolPrice,
        // getAvailableProduct,
    };
}

export default usePreload;
